import { ArrowPathIcon } from '@heroicons/react/24/outline';

export default function Input({
  label,
  labelClassName,
  className,
  error,
  touched,
  isDark = false,
  inputClassName,
  onReset,
  limit,
  ...props
}) {
  return (
    <div className={`${className}`}>
      {label && (
        <label htmlFor={props.name} className={`block ${labelClassName} `}>
          {label}
        </label>
      )}
      {onReset && props.value && (
        <ArrowPathIcon
          className="w-4 inline-block ml-2 cursor-pointer"
          title="reset"
          onClick={onReset}
        />
      )}
      <input
        maxLength={limit !== undefined && Number(limit) > 0 ? limit : undefined}
        id={props.name}
        className={`border px-2 py-2 rounded w-full ${isDark && 'bg-zinc-200'} ${inputClassName}`}
        {...props}
      />
      {limit !== undefined && Number(limit) > 0 && (
        <p className="text-sm text-gray-500">
          {props.value?.length || 0}/{limit}
        </p>
      )}
      {error && touched && (
        <p className="text text-red-500" data-tesid="error-text">
          {error}
        </p>
      )}
    </div>
  );
}

Input.defaultProps = {
  className: ''
};
